import { types } from "mobx-state-tree";
import TarotModel from "data/models/tarot";
import { random } from "lodash";

export default types
  .model({
    items: types.array(TarotModel),
  })
  .actions((self) => ({
    set(items) {
      self.items = items;
      return self;
    },

    getRandom() {
      return random(self.items);
    },
  }));
